"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickOutside = void 0;
const react_1 = require("react");
function useOnClickOutside(ref, onClickOutside) {
    const onClickOutsideRef = react_1.useRef(onClickOutside);
    react_1.useEffect(() => {
        onClickOutsideRef.current = onClickOutside;
    }, [onClickOutside]);
    react_1.useEffect(() => {
        const listener = (event) => {
            if (!event.target) {
                return;
            }
            if (!ref.current) {
                return;
            }
            try {
                if (!ref.current.contains(event.target)) {
                    onClickOutsideRef.current();
                }
            }
            catch (e) {
                if (process.env.NODE_ENV !== 'production') {
                    console.error(e);
                }
            }
        };
        document.addEventListener('click', listener);
        return () => {
            document.removeEventListener('click', listener);
        };
    }, [ref]);
}
exports.useOnClickOutside = useOnClickOutside;
//# sourceMappingURL=useOnClickOutside.js.map